export default __webpack_public_path__ + "1dcec29cf6b6723e757fd68fb1e18806.svg";